/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { Multicall__factory } from "./Multicall__factory";
export { Multicall2__factory } from "./Multicall2__factory";
